// Widget tipi → bileşen dağıtıcısı (Blazor HomePage switch'i).
import type { WidgetDefinition } from '../model/widgetLayout';
import { AnalogClockWidget } from '../widgets/AnalogClockWidget';
import { ClockWidget } from '../widgets/ClockWidget';
import { DashboardsWidget } from '../widgets/DashboardsWidget';
import { ExchangeRateWidget } from '../widgets/ExchangeRateWidget';
import { FavoritesWidget } from '../widgets/FavoritesWidget';
import { NotepadWidget } from '../widgets/NotepadWidget';
import { CalendarWidget } from '@/features/calendar';
import { PlaceholderWidget } from '../widgets/PlaceholderWidget';
import { RecentActivityWidget } from '../widgets/RecentActivityWidget';
import { WelcomeWidget } from '../widgets/WelcomeWidget';

export function WidgetRenderer({ widget }: { widget: WidgetDefinition }) {
  switch (widget.type) {
    case 'Welcome':
      return <WelcomeWidget />;
    case 'Clock':
      return <ClockWidget />;
    case 'AnalogClock':
      return <AnalogClockWidget />;
    case 'Favorites':
      return <FavoritesWidget />;
    case 'Dashboards':
      return <DashboardsWidget />;
    case 'Notepad':
      return <NotepadWidget widgetId={widget.id} />;
    case 'ExchangeRate':
      return <ExchangeRateWidget />;
    case 'RecentActivity':
      return <RecentActivityWidget />;
    case 'Calendar':
      return <CalendarWidget compact />;
    default:
      return <PlaceholderWidget type={widget.type} />;
  }
}
